export const FORMIK_PASSWORD_FIELD_DATA_IDS = {
  base: 'password-field',
  textField: '',
  inputAdornment: 'adornment',
  toggleButton: 'toggle',
  toggleIcon: 'toggle'
};
